<template>
  <div class="hld-qa">
    <div class="nav-bar">
      <i class="el-icon-arrow-left back-icon" @click="goBack()"></i>
      <span class="title">霍兰德职业兴趣测评</span>
      <div class="capsule"></div>
    </div>

    <div v-if="questions.length === 0" class="loading">
      <p>加载题库中...</p>
    </div>
    <div v-else>
      <div class="question-info">
        <div class="question-number">
          <span style="color: #936524 !important">{{
            currentQuestion + 1
          }}</span
          >/90题
        </div>
      </div>
      <div class="content">
        <div class="question-card">
          <div class="content">
            <div class="question-text">
              {{
                questions[currentQuestion]
                  ? questions[currentQuestion].text
                  : ""
              }}
            </div>
            <div class="options">
              <div
                v-if="questions[currentQuestion]"
                class="option yes-option"
                :class="{ active: selectedOption === '1' }"
                @click="handleOptionClick('1')"
              >
                1. 是
              </div>
              <div
                v-if="questions[currentQuestion]"
                class="option no-option"
                :class="{ active: selectedOption === '2' }"
                @click="handleOptionClick('2')"
              >
                2. 否
              </div>
            </div>
          </div>
        </div>
        <div class="button-section">
          <button
            class="back-button"
            @click="prevQuestion"
            v-if="currentQuestion !== 0"
          >
            返回上一题
          </button>
          <button
            v-if="currentQuestion === questions.length - 1 && selectedOption"
            class="result-button"
            @click="viewResult"
            :disabled="isSubmitting"
          >
            {{ isSubmitting ? "提交中..." : "提交" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getWechatUserProfile } from "@/assets/js/wechatAuth";

export default {
  name: "HLDQA",
  data() {
    return {
      currentQuestion: 0,
      selectedOption: "",
      answers: [],
      questions: [],
      originalData: [],
      isSubmitting: false, // 提交状态
    };
  },
  mounted() {
    this.fetchQuestions();
  },
  methods: {
    generateUUID() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    fetchQuestions() {
      console.log("开始获取题库数据");
      // 从接口获取题库数据
      this.$get("http://59.110.51.52:8010/system/web/survey?wjId=2")
        .then((res) => {
          console.log("获取题库成功:", res);
          if (res.data && res.data.topicTianBaos) {
            // 保存原始数据
            this.originalData = res.data;
            // 使用UUID给name赋值
            this.originalData.name = this.generateUUID();
            this.questions = res.data.topicTianBaos.map((topic) => ({
              id: topic.tmId,
              text: topic.tmName,
            }));
            console.log("题库数据转换完成:", this.questions);
          }
        })
        .catch((err) => {
          console.error("获取题库失败:", err);
          // 失败时使用模拟数据
          this.questions = Array.from({ length: 90 }, (_, index) => ({
            id: index + 1,
            text: `测试问题 ${index + 1}：我必须彻底了解事情的真相。`,
          }));
          console.log("使用模拟数据:", this.questions);
        });
    },
    goBack() {
      this.$router.push("/hld-action");
    },
    selectOption(option) {
      this.selectedOption = option;
      this.answers[this.currentQuestion] = option;

      // 自动进入下一题
      if (this.currentQuestion < this.questions.length - 1) {
        setTimeout(() => {
          // 确保currentQuestion不会超出questions数组的长度范围
          if (this.currentQuestion < this.questions.length - 1) {
            this.currentQuestion++;
            this.selectedOption = this.answers[this.currentQuestion] || "";
          }
        }, 500);
      }
      // 最后一题不自动提交，显示查看测评结果按钮
    },
    viewResult() {
      // 避免重复提交
      if (this.isSubmitting) return;
      // 提交测试结果
      this.submitTest();
    },
    prevQuestion() {
      if (this.currentQuestion > 0) {
        this.currentQuestion--;
        this.selectedOption = this.answers[this.currentQuestion] || "";
      }
    },
    submitTest() {
      // 设置提交状态为true
      this.isSubmitting = true;

      const wechatUser = getWechatUserProfile();

      // 准备提交数据
      let submitData;
      if (this.originalData) {
        // 如果有原始数据，使用原始数据结构
        submitData = {
          ...this.originalData,
          topicTianBaos: this.originalData.topicTianBaos.map(
            (topic, index) => ({
              ...topic,
              optionTianBaos: topic.optionTianBaos.map((option) => ({
                ...option,
                is_opt: this.answers[index] === option.xxXh ? 1 : 0,
              })),
            })
          ),
        };
      } else {
        // 否则使用简单数据结构
        submitData = {
          wjId: 2,
          answers: this.answers,
          name: this.generateUUID(), // 确保即使没有原始数据也有name字段
        };
      }

      submitData = {
        ...submitData,
        name: submitData.name || this.generateUUID(),
        brief: wechatUser.brief || "",
        openid: wechatUser.openid || "",
        nickName: wechatUser.nickName || "",
        sex: wechatUser.sex === "" ? "" : wechatUser.sex,
        headimgurl: wechatUser.headimgurl || "",
      };

      // 存储name的uuid为本地缓存
      localStorage.setItem("hldTestName", submitData.name);
      // 存储wjId为本地缓存
      localStorage.setItem("hldTestWjId", "2");

      const openid = wechatUser.openid || "";


      // 提交测试结果
      this.$post("http://59.110.51.52:8010/system/web/addsurvey", submitData)
        .then((res) => {
          if (res && res.code === 200) {
            this.$router.push({
              path: "/hld-result",
              query: { openid: openid, wjId: "2" },
            });
          } else {
            console.error("提交失败:", res.message);
            this.$router.push({
              path: "/hld-result",
              query: { openid: openid, wjId: "2" },
            });
          }
        })
        .catch((err) => {
          console.error("提交失败:", err);
          this.$router.push({
            path: "/hld-result",
            query: { openid: openid, wjId: "2" },
          });
        })

        .finally(() => {
          // 无论成功失败，都设置提交状态为false
          this.isSubmitting = false;
        });
    },
    testFillAll() {
      // 测试方法：点击第一题时直接把所有题的第一项或第二项随机变为1，然后跳转到最后一题
      if (this.currentQuestion === 0) {
        // 把所有题的第一项或第二项随机变为1
        for (let i = 0; i < this.questions.length; i++) {
          this.answers[i] = Math.random() > 0.5 ? "1" : "2"; // 随机选择第一项或第二项
        }
        // 跳转到最后一题
        this.currentQuestion = this.questions.length - 1;
        this.selectedOption = Math.random() > 0.5 ? "1" : "2"; // 随机选择第一项或第二项
      }
    },
    handleOptionClick(option) {
      // 处理选项点击
      this.selectOption(option);
      // 如果是第一题，调用测试方法
      // if (this.currentQuestion === 0) {
      //   this.testFillAll();
      // }
    },
    goBack() {
      this.$router.push("/hld-action");
    },
  },
};
</script>

<style scoped lang="scss">
.hld-qa {
  height: 100vh;
  background: linear-gradient(to bottom, #d7dbff, #ffffff);
  background-size: cover;
  padding: 20px;
  padding-top: 10px;
  position: relative;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 40px;
  padding-top: 10px;
}

.back-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  color: #333;
}

.header h1 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.more-options {
  display: flex;
  gap: 5px;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #999;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  font-size: 16px;
  color: #666;
}

.question-info {
  display: flex;
  justify-content: center;
}

.question-number {
  position: absolute;
  z-index: 999;
  top: 58px;
  background: linear-gradient(135deg, #fdf0b9 0%, #ffed4e 100%);
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  color: #d4a86c;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}

.question-card {
  width: 357px;
  height: 401px;
  background: url("~@/assets/images/hld-qa-bg.png") no-repeat center center;
  background-size: 100% 100%;
  border-radius: 20px;
  position: relative;
  left: 10px;
  .content {
    padding: 40px;
    width: calc(100% - 10px);
  }
}

.question-text {
  font-size: 18px;
  color: #333;
  line-height: 1.6;
  margin-bottom: 50px;
  text-align: center;
  position: relative;
  z-index: 1;
  width: 100%;
  margin-top: 60px;
}

.options {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  z-index: 1;
}

.option {
  padding: 16px;
  border-radius: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid transparent;
  color: #333;
  background: linear-gradient(135deg, #f6f5f8 0%, #f6f5f8 100%);
}

.yes-option {
}

.no-option {
  color: #333;
  border-color: #e0e0e0;
}

.option.active {
  color: #fff;
  background: linear-gradient(135deg, #7d92fa 0%, #b4c0fd 100%) !important;
  transform: translateY(-2px);
}

.button-section {
  width: 100%;
  max-width: 400px;
  display: flex;
  gap: 20px;
}

.back-button {
  flex: 1;
  padding: 15px;
  background: #e0e0e0;
  color: #666;
  border: none;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
}

.back-button:hover:not(:disabled) {
  background: #d0d0d0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.back-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.result-button {
  flex: 1;
  background: linear-gradient(135deg, #66b2ff 0%, #4a90e2 100%);
  color: #fff;
  border: none;
  padding: 15px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 178, 255, 0.3);
  text-align: center;
}

.result-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 178, 255, 0.4);
}

.result-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.nav-bar {
  padding: 0 !important;
  padding-top: 10px !important;
}
</style>